import { UserData, CategoryCounts, Question } from '../types';
import { calculateHighestCategory } from './calculateHighestCategory';

export interface QuizSubmissionData {
  email: string;
  forename: string;
  surname: string;
  phone?: string;
  result: string;
  answers: string;
  utm?: string;
}

class CustomError implements Error {
  constructor(s: string) {
    this.message = s;
    this.name = 'CustomError';
  }

  message: string;
  name: string;
}

export const submitQuizResults = async (
  userData: UserData,
  categoryCounts: CategoryCounts,
  answers: number[],
  questions: Question[]
): Promise<void> => {
  try {
    // Calculate the highest category
    const highestCategory = calculateHighestCategory(categoryCounts);
    const resultCategory = highestCategory.category;

    const formattedAnswers = answers
      .map((answerIndex, questionIndex) => ({
        question: questions[questionIndex]?.question || '',
        answer: questions[questionIndex]?.options[answerIndex]?.answer || '',
      }));

    const submissionData: QuizSubmissionData = {
      email: userData.email,
      forename: userData.forename,
      surname: userData.surname || '',
      phone: userData.telephone || '',
      result: resultCategory,
      answers: JSON.stringify(formattedAnswers),
      utm: JSON.stringify(userData.utm)
    };

    const response = await fetch('https://soloom-quiz-695091668299.europe-west2.run.app', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(submissionData)
    });

    if (!response.ok) {
      const errorText = await response.json();
      if (errorText.message) {
        throw new CustomError(`${errorText.message}`);
      } else {
        throw new Error('Neznáma chyba. Skúste to prosím znova.');
      }
    }
  } catch (error) {
    // Re-throw the error to be handled by the calling function
    if (error instanceof CustomError) {
      throw error;
    } else {
      throw new Error('Neznáma chyba. Skúste to prosím znova.');
    }
  }
};
